import { Icono } from './Icono';
import type { NombreIcono } from './iconos';
import './deslizador.css';

/**
 * RV Contexto (componentes.md §4d): el selector que elige de qué va toda la pantalla (aquí, de qué calendario es el
 * horario: «Todo el negocio» o una sede). Píldora de 44 con su icono, el valor recortado y un `select` nativo
 * transparente encima (rueda en iOS, lista en ordenador). `bloqueado`: solo consulta.
 */
export interface OpcionContexto {
    valor: string;
    texto: string;
}

interface Props {
    etiqueta: string;
    valor: string;
    opciones: readonly OpcionContexto[];
    icono: NombreIcono;
    onChange: (valor: string) => void;
    movil?: boolean;
    bloqueado?: boolean;
}

export function Contexto({ etiqueta, valor, opciones, icono, onChange, movil = false, bloqueado = false }: Props) {
    const elegida = opciones.find((o) => o.valor === valor)?.texto ?? '';
    return (
        <label className={`rv-ctx${movil ? ' rv-ctx--movil' : ''}${bloqueado ? ' rv-ctx--quieto' : ''}`}>
            <Icono nombre={icono} />
            <span className="rv-ctx__valor">{elegida}</span>
            <Icono nombre="chevron-down" className="rv-ctx__flecha" />
            <select
                aria-label={etiqueta}
                value={valor}
                disabled={bloqueado}
                onChange={(e) => {
                    onChange(e.target.value);
                }}
            >
                {opciones.map((o) => (
                    <option key={o.valor} value={o.valor}>
                        {o.texto}
                    </option>
                ))}
            </select>
        </label>
    );
}
